export const portalDashboardTranslations = {
  "de": {
    "month_activity": "Ticketentwicklung",
    "month_personal": "Meine Tickets",
    "month_opened": "Eröffnet",
    "month_closed": "Abgeschlossen",
    "month_chart_summary": "{{month}}: {{opened}} Tickets eröffnet, {{closed}} abgeschlossen. Tageswerte stehen unter dem Diagramm.",
    "month_method": "Tageswerte in UTC · Abgeschlossen: aktuell gelöste oder geschlossene Tickets nach Lösungs-/Abschlussdatum.",
    "month_values": "Tageswerte anzeigen",
    "month_day": "Tag",
    "loading": "Portal wird geladen",
    "load_failed": "Die Support-Übersicht konnte nicht geladen werden",
    "unchanged": "Ihre Daten wurden nicht verändert.",
    "retry": "Erneut versuchen",
    "morning": "Guten Morgen",
    "day": "Guten Tag",
    "evening": "Guten Abend",
    "welcome": "willkommen",
    "incident": "Störung melden",
    "incident_desc": "Ausfall oder dringendes Problem priorisiert erfassen",
    "request": "Service anfragen",
    "request_desc": "Zugang, Gerät, Software oder Änderung bestellen",
    "tickets": "Meine Vorgänge",
    "tickets_desc": "Status prüfen und direkt auf Rückfragen antworten",
    "documents": "Neue Dokumente",
    "documents_desc": "Freigaben und aktuelle Leistungsnachweise öffnen",
    "intro": "Hier sehen Sie, was als Nächstes wichtig ist.",
    "reply_hint": "Jetzt antworten, damit die Bearbeitung weitergehen kann.",
    "open": "Öffnen →",
    "active": "Aktive Tickets",
    "your_reply": "Ihre Antwort",
    "waiting": "Rückfragen warten auf Sie",
    "no_waiting": "Aktuell keine Rückfrage",
    "resolution": "Ø Lösungszeit",
    "resolved_hint": "Aus abgeschlossenen Vorgängen",
    "completion": "Abschlussquote",
    "company_tickets": "Firmenweite Supportvorgänge",
    "own_tickets": "Ihre Supportvorgänge",
    "recent": "Aktuelle Vorgänge",
    "recent_hint": "Bis zu 12 Vorgänge · Rückfragen zuerst, danach letzte Aktualisierung. Alle Vorgänge finden Sie unter „Alle Tickets“.",
    "all": "Alle Tickets",
    "next": "Nächster Schritt:",
    "answer": "Rückfrage des Supportteams beantworten",
    "working": "Bearbeitung durch das Supportteam",
    "empty": "Keine aktuellen Vorgänge. Sie können jederzeit eine neue Anfrage erstellen.",
    "quick": "Schnell zur Lösung",
    "quick_hint": "Den passenden Supportweg direkt starten",
    "search_kb": "Wissensbasis durchsuchen",
    "incoming": "Eingegangene Vorgänge",
    "incoming_hint": "Neu erstellte firmenweite Tickets · letzte 12 Monate",
    "contact": "Hauptansprechpartner",
    "monthly": "Monatliche Ticketentwicklung",
    "contract": "Vertrag & Verbrauch",
    "contact_only": "Nur mit Firmenzugriff sichtbar",
    "time": "Bearbeitungszeit",
    "count": "Vorgänge",
    "contracts_link": "Verträge und Leistungsnachweise öffnen →",
    "resolved_count": "{{count}} bereits abgeschlossen",
    "needs_reply": "{{count}} Ticket(s) benötigen Ihre Antwort",
    "page": "Ticketseite {{count}}",
    "of": "von",
    "refresh": "Aktualisieren",
    "create_request": "Anfrage erstellen",
    "new_request": "Neue Anfrage",
    "my_support": "Mein Support",
    "employee": "Mitarbeiter",
    "privacy": "Datenschutz",
    "imprint": "Impressum",
    "operator": "Betreiber-Informationen"
  },
  "en": {
    "month_activity": "Ticket activity",
    "month_personal": "My tickets",
    "month_opened": "Opened",
    "month_closed": "Completed",
    "month_chart_summary": "{{month}}: {{opened}} tickets opened, {{closed}} completed. Daily values are available below the chart.",
    "month_method": "Daily values in UTC · Completed: currently resolved or closed tickets by resolution/completion date.",
    "month_values": "Show daily values",
    "month_day": "Day",
    "loading": "Loading portal",
    "load_failed": "Could not load the support overview",
    "unchanged": "Your data has not been changed.",
    "retry": "Try again",
    "morning": "Good morning",
    "day": "Hello",
    "evening": "Good evening",
    "welcome": "welcome",
    "incident": "Report an incident",
    "incident_desc": "Report an outage or urgent problem",
    "request": "Request a service",
    "request_desc": "Request access, equipment, software or a change",
    "tickets": "My tickets",
    "tickets_desc": "Check progress and respond to questions",
    "documents": "Documents",
    "documents_desc": "Open shared documents and service records",
    "intro": "See what needs your attention next.",
    "reply_hint": "Reply now so we can continue working.",
    "open": "Open →",
    "active": "Active tickets",
    "your_reply": "Your reply",
    "waiting": "Questions await your reply",
    "no_waiting": "No questions awaiting your reply",
    "resolution": "Average resolution time",
    "resolved_hint": "Based on completed tickets",
    "completion": "Completion rate",
    "company_tickets": "Company-wide tickets",
    "own_tickets": "Your support tickets",
    "recent": "Recent tickets",
    "recent_hint": "Up to 12 tickets · Questions first, then latest update. Open All tickets for the full list.",
    "all": "All tickets",
    "next": "Next step:",
    "answer": "Reply to the support team",
    "working": "The support team is working on your ticket",
    "empty": "No recent tickets. You can create a request at any time.",
    "quick": "Find a solution",
    "quick_hint": "Choose how we can help",
    "search_kb": "Search the knowledge base",
    "incoming": "Incoming tickets",
    "incoming_hint": "New company-wide tickets · last 12 months",
    "contact": "Primary contact",
    "monthly": "Monthly ticket activity",
    "contract": "Contract & usage",
    "contact_only": "Visible with company portal access only",
    "time": "Processing time",
    "count": "Tickets",
    "contracts_link": "Open contracts and service records →",
    "resolved_count": "{{count}} completed",
    "needs_reply": "{{count}} ticket(s) need your reply",
    "page": "Ticket page {{count}}",
    "of": "of",
    "refresh": "Refresh",
    "create_request": "Create a request",
    "new_request": "New request",
    "my_support": "My support",
    "employee": "Employee",
    "privacy": "Privacy",
    "imprint": "Legal notice",
    "operator": "Operator information"
  },
  "fr": {
    "month_activity": "Évolution des tickets",
    "month_personal": "Mes tickets",
    "month_opened": "Ouverts",
    "month_closed": "Terminés",
    "month_chart_summary": "{{month}} : {{opened}} tickets ouverts, {{closed}} terminés. Les valeurs quotidiennes sont disponibles sous le graphique.",
    "month_method": "Valeurs quotidiennes en UTC · Terminés : tickets actuellement résolus ou fermés, selon la date de résolution/clôture.",
    "month_values": "Afficher les valeurs quotidiennes",
    "month_day": "Jour",
    "loading": "Chargement du portail",
    "load_failed": "Impossible de charger la vue d'ensemble du support",
    "unchanged": "Vos données n'ont pas été modifiées.",
    "retry": "Réessayer",
    "morning": "Bonjour",
    "day": "Bonjour",
    "evening": "Bonsoir",
    "welcome": "bienvenue",
    "incident": "Signaler un incident",
    "incident_desc": "Signaler une panne ou un problème urgent",
    "request": "Demander un service",
    "request_desc": "Demander un accès, un équipement, un logiciel ou une modification",
    "tickets": "Mes tickets",
    "tickets_desc": "Consulter l'avancement et répondre aux questions",
    "documents": "Documents",
    "documents_desc": "Ouvrir les documents partagés et les relevés de service",
    "intro": "Voici les prochaines actions importantes.",
    "reply_hint": "Répondez pour permettre la poursuite du traitement.",
    "open": "Ouvrir →",
    "active": "Tickets actifs",
    "your_reply": "Votre réponse",
    "waiting": "Des questions attendent votre réponse",
    "no_waiting": "Aucune question en attente",
    "resolution": "Délai moyen de résolution",
    "resolved_hint": "D'après les tickets terminés",
    "completion": "Taux de clôture",
    "company_tickets": "Tickets de toute l'entreprise",
    "own_tickets": "Vos tickets de support",
    "recent": "Tickets récents",
    "recent_hint": "Jusqu'à 12 tickets · Questions en premier, puis dernière mise à jour. Tous les tickets donne accès à la liste complète.",
    "all": "Tous les tickets",
    "next": "Prochaine étape :",
    "answer": "Répondre à l'équipe de support",
    "working": "L'équipe de support traite votre ticket",
    "empty": "Aucun ticket récent. Vous pouvez créer une demande à tout moment.",
    "quick": "Trouver une solution",
    "quick_hint": "Choisissez comment nous pouvons vous aider",
    "search_kb": "Rechercher dans la base de connaissances",
    "incoming": "Tickets reçus",
    "incoming_hint": "Nouveaux tickets de l'entreprise · 12 derniers mois",
    "contact": "Contact principal",
    "monthly": "Évolution mensuelle des tickets",
    "contract": "Contrat et consommation",
    "contact_only": "Visible avec un accès au portail de l’entreprise",
    "time": "Temps de traitement",
    "count": "Tickets",
    "contracts_link": "Ouvrir les contrats et relevés de service →",
    "resolved_count": "{{count}} terminés",
    "needs_reply": "{{count}} ticket(s) attendent votre réponse",
    "page": "Page de tickets {{count}}",
    "of": "sur",
    "refresh": "Actualiser",
    "create_request": "Créer une demande",
    "new_request": "Nouvelle demande",
    "my_support": "Mon support",
    "employee": "Employé",
    "privacy": "Confidentialité",
    "imprint": "Mentions légales",
    "operator": "Informations sur l’opérateur"
  },
  "es": {
    "month_activity": "Evolución de tickets",
    "month_personal": "Mis tickets",
    "month_opened": "Abiertos",
    "month_closed": "Completados",
    "month_chart_summary": "{{month}}: {{opened}} tickets abiertos, {{closed}} completados. Los valores diarios están debajo del gráfico.",
    "month_method": "Valores diarios en UTC · Completados: tickets actualmente resueltos o cerrados según su fecha de resolución/cierre.",
    "month_values": "Mostrar valores diarios",
    "month_day": "Día",
    "loading": "Cargando el portal",
    "load_failed": "No se pudo cargar el resumen de soporte",
    "unchanged": "Sus datos no se han modificado.",
    "retry": "Reintentar",
    "morning": "Buenos días",
    "day": "Buenas tardes",
    "evening": "Buenas noches",
    "welcome": "bienvenido",
    "incident": "Informar de una incidencia",
    "incident_desc": "Informar de una interrupción o un problema urgente",
    "request": "Solicitar un servicio",
    "request_desc": "Solicitar acceso, equipo, software o un cambio",
    "tickets": "Mis tickets",
    "tickets_desc": "Consultar el estado y responder a las preguntas",
    "documents": "Documentos",
    "documents_desc": "Abrir documentos compartidos e informes de servicio",
    "intro": "Consulte lo que requiere su atención a continuación.",
    "reply_hint": "Responda para que podamos continuar.",
    "open": "Abrir →",
    "active": "Tickets activos",
    "your_reply": "Su respuesta",
    "waiting": "Hay preguntas pendientes de su respuesta",
    "no_waiting": "No hay preguntas pendientes",
    "resolution": "Tiempo medio de resolución",
    "resolved_hint": "Basado en tickets finalizados",
    "completion": "Tasa de cierre",
    "company_tickets": "Tickets de toda la empresa",
    "own_tickets": "Sus tickets de soporte",
    "recent": "Tickets recientes",
    "recent_hint": "Hasta 12 tickets · Primero las preguntas, después la última actualización. Todos los tickets muestra la lista completa.",
    "all": "Todos los tickets",
    "next": "Siguiente paso:",
    "answer": "Responder al equipo de soporte",
    "working": "El equipo de soporte está trabajando en su ticket",
    "empty": "No hay tickets recientes. Puede crear una solicitud en cualquier momento.",
    "quick": "Encontrar una solución",
    "quick_hint": "Elija cómo podemos ayudarle",
    "search_kb": "Buscar en la base de conocimientos",
    "incoming": "Tickets recibidos",
    "incoming_hint": "Nuevos tickets de la empresa · últimos 12 meses",
    "contact": "Contacto principal",
    "monthly": "Evolución mensual de tickets",
    "contract": "Contrato y consumo",
    "contact_only": "Visible con acceso al portal de la empresa",
    "time": "Tiempo de trabajo",
    "count": "Tickets",
    "contracts_link": "Abrir contratos e informes de servicio →",
    "resolved_count": "{{count}} finalizados",
    "needs_reply": "{{count}} ticket(s) necesitan su respuesta",
    "page": "Página de tickets {{count}}",
    "of": "de",
    "refresh": "Actualizar",
    "create_request": "Crear una solicitud",
    "new_request": "Nueva solicitud",
    "my_support": "Mi soporte",
    "employee": "Empleado",
    "privacy": "Privacidad",
    "imprint": "Aviso legal",
    "operator": "Información del operador"
  },
  "pt": {
    "month_activity": "Evolução dos pedidos",
    "month_personal": "Os meus pedidos",
    "month_opened": "Abertos",
    "month_closed": "Concluídos",
    "month_chart_summary": "{{month}}: {{opened}} pedidos abertos, {{closed}} concluídos. Os valores diários estão abaixo do gráfico.",
    "month_method": "Valores diários em UTC · Concluídos: pedidos atualmente resolvidos ou fechados pela data de resolução/fecho.",
    "month_values": "Mostrar valores diários",
    "month_day": "Dia",
    "loading": "A carregar o portal",
    "load_failed": "Não foi possível carregar o resumo do suporte",
    "unchanged": "Os seus dados não foram alterados.",
    "retry": "Tentar novamente",
    "morning": "Bom dia",
    "day": "Boa tarde",
    "evening": "Boa noite",
    "welcome": "bem-vindo",
    "incident": "Comunicar um incidente",
    "incident_desc": "Comunicar uma falha ou um problema urgente",
    "request": "Pedir um serviço",
    "request_desc": "Pedir acesso, equipamento, software ou uma alteração",
    "tickets": "Os meus pedidos",
    "tickets_desc": "Consultar o estado e responder a perguntas",
    "documents": "Documentos",
    "documents_desc": "Abrir documentos partilhados e registos de serviço",
    "intro": "Veja o que precisa da sua atenção a seguir.",
    "reply_hint": "Responda para podermos continuar.",
    "open": "Abrir →",
    "active": "Pedidos ativos",
    "your_reply": "A sua resposta",
    "waiting": "Há perguntas à espera da sua resposta",
    "no_waiting": "Não há perguntas pendentes",
    "resolution": "Tempo médio de resolução",
    "resolved_hint": "Com base em pedidos concluídos",
    "completion": "Taxa de conclusão",
    "company_tickets": "Pedidos de toda a empresa",
    "own_tickets": "Os seus pedidos de suporte",
    "recent": "Pedidos recentes",
    "recent_hint": "Até 12 pedidos · Perguntas primeiro, depois a última atualização. Todos os pedidos abre a lista completa.",
    "all": "Todos os pedidos",
    "next": "Próximo passo:",
    "answer": "Responder à equipa de suporte",
    "working": "A equipa de suporte está a tratar do seu pedido",
    "empty": "Não há pedidos recentes. Pode criar um pedido a qualquer momento.",
    "quick": "Encontrar uma solução",
    "quick_hint": "Escolha como podemos ajudar",
    "search_kb": "Pesquisar na base de conhecimentos",
    "incoming": "Pedidos recebidos",
    "incoming_hint": "Novos pedidos da empresa · últimos 12 meses",
    "contact": "Contacto principal",
    "monthly": "Evolução mensal dos pedidos",
    "contract": "Contrato e consumo",
    "contact_only": "Visível com acesso ao portal da empresa",
    "time": "Tempo de trabalho",
    "count": "Pedidos",
    "contracts_link": "Abrir contratos e registos de serviço →",
    "resolved_count": "{{count}} concluídos",
    "needs_reply": "{{count}} pedido(s) precisam da sua resposta",
    "page": "Página de pedidos {{count}}",
    "of": "de",
    "refresh": "Atualizar",
    "create_request": "Criar um pedido",
    "new_request": "Novo pedido",
    "my_support": "O meu suporte",
    "employee": "Colaborador",
    "privacy": "Privacidade",
    "imprint": "Aviso legal",
    "operator": "Informações do operador"
  },
  "nl": {
    "month_activity": "Ticketontwikkeling",
    "month_personal": "Mijn tickets",
    "month_opened": "Geopend",
    "month_closed": "Afgerond",
    "month_chart_summary": "{{month}}: {{opened}} tickets geopend, {{closed}} afgerond. Dagwaarden staan onder de grafiek.",
    "month_method": "Dagwaarden in UTC · Afgerond: momenteel opgeloste of gesloten tickets volgens de oplossings-/sluitingsdatum.",
    "month_values": "Dagwaarden tonen",
    "month_day": "Dag",
    "loading": "Portaal laden",
    "load_failed": "Het supportoverzicht kon niet worden geladen",
    "unchanged": "Uw gegevens zijn niet gewijzigd.",
    "retry": "Opnieuw proberen",
    "morning": "Goedemorgen",
    "day": "Goedendag",
    "evening": "Goedenavond",
    "welcome": "welkom",
    "incident": "Storing melden",
    "incident_desc": "Een uitval of dringend probleem melden",
    "request": "Service aanvragen",
    "request_desc": "Toegang, apparatuur, software of een wijziging aanvragen",
    "tickets": "Mijn tickets",
    "tickets_desc": "Voortgang bekijken en vragen beantwoorden",
    "documents": "Documenten",
    "documents_desc": "Gedeelde documenten en servicerapporten openen",
    "intro": "Bekijk wat nu uw aandacht nodig heeft.",
    "reply_hint": "Antwoord zodat we verder kunnen werken.",
    "open": "Openen →",
    "active": "Actieve tickets",
    "your_reply": "Uw antwoord",
    "waiting": "Er wachten vragen op uw antwoord",
    "no_waiting": "Geen openstaande vragen",
    "resolution": "Gemiddelde oplostijd",
    "resolved_hint": "Gebaseerd op afgeronde tickets",
    "completion": "Afsluitpercentage",
    "company_tickets": "Tickets van het hele bedrijf",
    "own_tickets": "Uw supporttickets",
    "recent": "Recente tickets",
    "recent_hint": "Maximaal 12 tickets · Eerst vragen, daarna de laatste update. Alle tickets toont de volledige lijst.",
    "all": "Alle tickets",
    "next": "Volgende stap:",
    "answer": "De vraag van het supportteam beantwoorden",
    "working": "Het supportteam werkt aan uw ticket",
    "empty": "Geen recente tickets. U kunt op elk moment een aanvraag indienen.",
    "quick": "Een oplossing vinden",
    "quick_hint": "Kies hoe we u kunnen helpen",
    "search_kb": "Kennisbank doorzoeken",
    "incoming": "Binnengekomen tickets",
    "incoming_hint": "Nieuwe bedrijfstickets · afgelopen 12 maanden",
    "contact": "Hoofdcontactpersoon",
    "monthly": "Maandelijkse ticketontwikkeling",
    "contract": "Contract en verbruik",
    "contact_only": "Alleen zichtbaar met bedrijfstoegang",
    "time": "Bewerkingstijd",
    "count": "Tickets",
    "contracts_link": "Contracten en servicerapporten openen →",
    "resolved_count": "{{count}} afgerond",
    "needs_reply": "{{count}} ticket(s) wachten op uw antwoord",
    "page": "Ticketpagina {{count}}",
    "of": "van",
    "refresh": "Vernieuwen",
    "create_request": "Aanvraag indienen",
    "new_request": "Nieuwe aanvraag",
    "my_support": "Mijn support",
    "employee": "Medewerker",
    "privacy": "Privacy",
    "imprint": "Juridische informatie",
    "operator": "Informatie over de beheerder"
  },
  "pl": {
    "month_activity": "Liczba zgłoszeń",
    "month_personal": "Moje zgłoszenia",
    "month_opened": "Utworzone",
    "month_closed": "Zakończone",
    "month_chart_summary": "{{month}}: {{opened}} zgłoszeń utworzonych, {{closed}} zakończonych. Wartości dzienne znajdują się pod wykresem.",
    "month_method": "Wartości dzienne w UTC · Zakończone: aktualnie rozwiązane lub zamknięte zgłoszenia według daty rozwiązania/zamknięcia.",
    "month_values": "Pokaż wartości dzienne",
    "month_day": "Dzień",
    "loading": "Ładowanie portalu",
    "load_failed": "Nie można załadować przeglądu wsparcia",
    "unchanged": "Twoje dane nie zostały zmienione.",
    "retry": "Spróbuj ponownie",
    "morning": "Dzień dobry",
    "day": "Dzień dobry",
    "evening": "Dobry wieczór",
    "welcome": "witaj",
    "incident": "Zgłoś awarię",
    "incident_desc": "Zgłoś przerwę w działaniu lub pilny problem",
    "request": "Zamów usługę",
    "request_desc": "Zamów dostęp, sprzęt, oprogramowanie lub zmianę",
    "tickets": "Moje zgłoszenia",
    "tickets_desc": "Sprawdź postęp i odpowiedz na pytania",
    "documents": "Dokumenty",
    "documents_desc": "Otwórz udostępnione dokumenty i raporty usług",
    "intro": "Zobacz, co wymaga teraz Twojej uwagi.",
    "reply_hint": "Odpowiedz, abyśmy mogli kontynuować pracę.",
    "open": "Otwórz →",
    "active": "Aktywne zgłoszenia",
    "your_reply": "Twoja odpowiedź",
    "waiting": "Pytania czekają na Twoją odpowiedź",
    "no_waiting": "Brak pytań oczekujących na odpowiedź",
    "resolution": "Średni czas rozwiązania",
    "resolved_hint": "Na podstawie zakończonych zgłoszeń",
    "completion": "Odsetek zamkniętych",
    "company_tickets": "Zgłoszenia całej firmy",
    "own_tickets": "Twoje zgłoszenia do wsparcia",
    "recent": "Ostatnie zgłoszenia",
    "recent_hint": "Do 12 zgłoszeń · Najpierw pytania, potem ostatnia aktualizacja. Wszystkie zgłoszenia otwiera pełną listę.",
    "all": "Wszystkie zgłoszenia",
    "next": "Następny krok:",
    "answer": "Odpowiedz zespołowi wsparcia",
    "working": "Zespół wsparcia pracuje nad zgłoszeniem",
    "empty": "Brak ostatnich zgłoszeń. Możesz utworzyć zgłoszenie w dowolnym momencie.",
    "quick": "Znajdź rozwiązanie",
    "quick_hint": "Wybierz sposób uzyskania pomocy",
    "search_kb": "Przeszukaj bazę wiedzy",
    "incoming": "Otrzymane zgłoszenia",
    "incoming_hint": "Nowe zgłoszenia firmy · ostatnie 12 miesięcy",
    "contact": "Główna osoba kontaktowa",
    "monthly": "Miesięczna liczba zgłoszeń",
    "contract": "Umowa i wykorzystanie",
    "contact_only": "Widoczne tylko z dostępem do firmy",
    "time": "Czas pracy",
    "count": "Zgłoszenia",
    "contracts_link": "Otwórz umowy i raporty usług →",
    "resolved_count": "{{count}} zakończonych",
    "needs_reply": "{{count}} zgłoszeń wymaga odpowiedzi",
    "page": "Strona zgłoszeń {{count}}",
    "of": "z",
    "refresh": "Odśwież",
    "create_request": "Utwórz zgłoszenie",
    "new_request": "Nowe zgłoszenie",
    "my_support": "Moje wsparcie",
    "employee": "Pracownik",
    "privacy": "Prywatność",
    "imprint": "Informacje prawne",
    "operator": "Informacje o operatorze"
  },
  "ru": {
    "month_activity": "Динамика заявок",
    "month_personal": "Мои заявки",
    "month_opened": "Создано",
    "month_closed": "Завершено",
    "month_chart_summary": "{{month}}: создано {{opened}} заявок, завершено {{closed}}. Дневные значения доступны под графиком.",
    "month_method": "Дневные значения в UTC · Завершено: заявки, которые сейчас решены или закрыты, по дате решения/закрытия.",
    "month_values": "Показать дневные значения",
    "month_day": "День",
    "loading": "Загрузка портала",
    "load_failed": "Не удалось загрузить обзор поддержки",
    "unchanged": "Ваши данные не изменены.",
    "retry": "Повторить",
    "morning": "Доброе утро",
    "day": "Добрый день",
    "evening": "Добрый вечер",
    "welcome": "добро пожаловать",
    "incident": "Сообщить о сбое",
    "incident_desc": "Сообщить об отказе или срочной проблеме",
    "request": "Запросить услугу",
    "request_desc": "Запросить доступ, оборудование, ПО или изменение",
    "tickets": "Мои заявки",
    "tickets_desc": "Проверить ход работы и ответить на вопросы",
    "documents": "Документы",
    "documents_desc": "Открыть общие документы и отчёты об услугах",
    "intro": "Посмотрите, что требует вашего внимания.",
    "reply_hint": "Ответьте, чтобы мы могли продолжить работу.",
    "open": "Открыть →",
    "active": "Активные заявки",
    "your_reply": "Ваш ответ",
    "waiting": "Есть вопросы, ожидающие вашего ответа",
    "no_waiting": "Нет вопросов, ожидающих ответа",
    "resolution": "Среднее время решения",
    "resolved_hint": "По завершённым заявкам",
    "completion": "Доля закрытых заявок",
    "company_tickets": "Заявки всей компании",
    "own_tickets": "Ваши заявки в поддержку",
    "recent": "Последние заявки",
    "recent_hint": "До 12 заявок · Сначала вопросы, затем последнее обновление. Все заявки открывает полный список.",
    "all": "Все заявки",
    "next": "Следующий шаг:",
    "answer": "Ответить службе поддержки",
    "working": "Служба поддержки работает над заявкой",
    "empty": "Последних заявок нет. Вы можете создать заявку в любое время.",
    "quick": "Найти решение",
    "quick_hint": "Выберите подходящий способ поддержки",
    "search_kb": "Поиск в базе знаний",
    "incoming": "Полученные заявки",
    "incoming_hint": "Новые заявки компании · последние 12 месяцев",
    "contact": "Основное контактное лицо",
    "monthly": "Динамика заявок по месяцам",
    "contract": "Договор и использование",
    "contact_only": "Доступно только с доступом к порталу компании",
    "time": "Время работы",
    "count": "Заявки",
    "contracts_link": "Открыть договоры и отчёты об услугах →",
    "resolved_count": "Завершено: {{count}}",
    "needs_reply": "Заявок, требующих ответа: {{count}}",
    "page": "Страница заявок {{count}}",
    "of": "из",
    "refresh": "Обновить",
    "create_request": "Создать заявку",
    "new_request": "Новая заявка",
    "my_support": "Моя поддержка",
    "employee": "Сотрудник",
    "privacy": "Конфиденциальность",
    "imprint": "Правовая информация",
    "operator": "Информация об операторе"
  },
  "be": {
    "month_activity": "Ticketontwikkeling",
    "month_personal": "Mijn tickets",
    "month_opened": "Geopend",
    "month_closed": "Afgerond",
    "month_chart_summary": "{{month}}: {{opened}} tickets geopend, {{closed}} afgerond. Dagwaarden staan onder de grafiek.",
    "month_method": "Dagwaarden in UTC · Afgerond: momenteel opgeloste of gesloten tickets volgens de oplossings-/sluitingsdatum.",
    "month_values": "Dagwaarden tonen",
    "month_day": "Dag",
    "loading": "Portaal laden",
    "load_failed": "Het supportoverzicht kon niet worden geladen",
    "unchanged": "Uw gegevens zijn niet gewijzigd.",
    "retry": "Opnieuw proberen",
    "morning": "Goedemorgen",
    "day": "Goedendag",
    "evening": "Goedenavond",
    "welcome": "welkom",
    "incident": "Storing melden",
    "incident_desc": "Een uitval of dringend probleem melden",
    "request": "Service aanvragen",
    "request_desc": "Toegang, apparatuur, software of een wijziging aanvragen",
    "tickets": "Mijn tickets",
    "tickets_desc": "Voortgang bekijken en vragen beantwoorden",
    "documents": "Documenten",
    "documents_desc": "Gedeelde documenten en servicerapporten openen",
    "intro": "Bekijk wat nu uw aandacht nodig heeft.",
    "reply_hint": "Antwoord zodat we verder kunnen werken.",
    "open": "Openen →",
    "active": "Actieve tickets",
    "your_reply": "Uw antwoord",
    "waiting": "Er wachten vragen op uw antwoord",
    "no_waiting": "Geen openstaande vragen",
    "resolution": "Gemiddelde oplostijd",
    "resolved_hint": "Gebaseerd op afgeronde tickets",
    "completion": "Afsluitpercentage",
    "company_tickets": "Tickets van het hele bedrijf",
    "own_tickets": "Uw supporttickets",
    "recent": "Recente tickets",
    "recent_hint": "Maximaal 12 tickets · Eerst vragen, daarna de laatste update. Alle tickets toont de volledige lijst.",
    "all": "Alle tickets",
    "next": "Volgende stap:",
    "answer": "De vraag van het supportteam beantwoorden",
    "working": "Het supportteam werkt aan uw ticket",
    "empty": "Geen recente tickets. U kunt op elk moment een aanvraag indienen.",
    "quick": "Een oplossing vinden",
    "quick_hint": "Kies hoe we u kunnen helpen",
    "search_kb": "Kennisbank doorzoeken",
    "incoming": "Binnengekomen tickets",
    "incoming_hint": "Nieuwe bedrijfstickets · afgelopen 12 maanden",
    "contact": "Hoofdcontactpersoon",
    "monthly": "Maandelijkse ticketontwikkeling",
    "contract": "Contract en verbruik",
    "contact_only": "Alleen zichtbaar met bedrijfstoegang",
    "time": "Bewerkingstijd",
    "count": "Tickets",
    "contracts_link": "Contracten en servicerapporten openen →",
    "resolved_count": "{{count}} afgerond",
    "needs_reply": "{{count}} ticket(s) wachten op uw antwoord",
    "page": "Ticketpagina {{count}}",
    "of": "van",
    "refresh": "Vernieuwen",
    "create_request": "Aanvraag indienen",
    "new_request": "Nieuwe aanvraag",
    "my_support": "Mijn support",
    "employee": "Medewerker",
    "privacy": "Privacy",
    "imprint": "Juridische informatie",
    "operator": "Informatie over de beheerder"
  }
};
